<template>
    <div>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="月度" name="month">
                <el-row style="height: 40px; line-height: 40px">
                    <el-col :span="14">
                        <reportMonth :handleSelectInput="handleSelectInputMonth"></reportMonth>
                    </el-col>
                    <el-col :span="10">
                        <div style="float: right">
                            <span style="font-size: 16px; font-weight: bold; margin-right: 10px">辖区</span>
                            <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                        </div>
                    </el-col>
                </el-row>
                <div class="btn" style="margin-top: 20px;margin-bottom: 20px">
                    <el-button size="small" style="background: #4EC880;border:none;color: #fff"
                        @click.stop="searchWeekList">查询</el-button>
                    <!-- <el-button size="small" style="background: #D0021B;border:none;color: #fff"
                        @click.stop="ResetClick">重置</el-button> -->
                    <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff"
                        icon="el-icon-upload2" @click.stop="exportMonthDataClick">
                        导出明细数据
                    </el-button>
                </div>
                <div class="tableCss">
                    <el-table :data="tableData" border style="width: 100%" max-height="500">
                        <el-table-column fixed align="center" type="index" width="50">
                        </el-table-column>
                        <el-table-column align="center" label="项目名称" prop="project_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="产品" prop="product_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="医院" prop="institution_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="销售代表" prop="alias" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="项目经理" prop="manager_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="月份" prop="month" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="月销售实际完成" prop="actual_amount" min-width="120">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="季度" name="quarter">
                <el-row style="height: 40px; line-height: 40px">
                    <el-col :span="14">
                        <div style="display: flex;">
                            <div>
                                <el-date-picker style="width: 120px" v-model="year" format="yyyy年" value-format="yyyy"
                                    type="year" placeholder="选择年">
                                </el-date-picker>
                            </div>
                            <div>
                                <el-select style="width: 120px;margin-left: 20px;" v-model="quarter" placeholder="请选择">
                                    <el-option v-for="item in options" :key="item.key" :label="item.value"
                                        :value="item.key">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div style="float: right">
                            <span style="font-size: 16px; font-weight: bold; margin-right: 10px">辖区</span>
                            <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                        </div>
                    </el-col>
                </el-row>
                <div class="btn" style="margin-top: 20px;margin-bottom: 20px">
                    <el-button size="small" style="background: #4EC880;border:none;color: #fff"
                        @click.stop="searchWeekList">查询</el-button>
                    <!-- <el-button size="small" style="background: #D0021B;border:none;color: #fff"
                        @click.stop="ResetClick">重置</el-button> -->
                    <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff"
                        icon="el-icon-upload2" @click.stop="exportQuarterDataClick">
                        导出汇总数据
                    </el-button>
                </div>
                <div class="tableCss">
                    <el-table :data="tableData" border style="width: 100%" max-height="500">
                        <el-table-column fixed align="center" type="index" width="50">
                        </el-table-column>
                        <el-table-column align="center" label="季度" prop="quarter" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="项目名称" prop="project_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="产品" prop="product_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="销售代表" prop="alias" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="项目经理" prop="manager_name" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="季度指标" prop="target_amount" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="季度销售实际完成" prop="actual_amount" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="季度指标达成率" prop="achieve_rate" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="实际销售同比增长" prop="tongbu_actual_amount" min-width="120">
                        </el-table-column>
                        <el-table-column align="center" label="指标达成率同比增长" prop="tongbu_achieve_rate" min-width="150">
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import reportMonth from "./reportMonth";
import moment from "moment";
import popedom from "./popedom";
import http from "../../../APIService/http";
  import axios from "axios";
export default {
    name: "CSO_SalesDataReport",
    data() {
        return {
            territory_id: '',
            tableData: [],

            options: [
                { key: 'Q1', value: '第一季度' },
                { key: 'Q2', value: '第二季度' },
                { key: 'Q3', value: '第三季度' },
                { key: 'Q4', value: '第四季度' }
            ],
            activeName: 'month',
            month: "",
            quarter: '',
            year: ''
        }
    },
    components: {
        popedom,
        reportMonth,
    },
    methods: {
        handleClick(tab, event) {
            this.activeName = tab.name;
            this.getSalesData();
        },
        ResetClick() {

        },
        searchWeekList() {
            this.getSalesData();
        },
        handleSelectInputMonth(j) {
            this.month = j;
        },
        handleSelectInputClick(e) {
            console.log("----handleSelectInputClick---", this.GLOBAL.territory_id);
            this.searchWeekList();
        },
        shelfData() {
            console.log("----shelfData---", this.GLOBAL.territory_id);
        },

        async getSalesData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let user = this.$store.getters.getUser
                let data = {
                    user_id: user.user_id,
                    tenant_id: user.tenant_id,
                    territory_id: this.GLOBAL.territory_id,
                    month: this.GLOBAL.date ? moment(this.GLOBAL.date).format("YYYYMM") : moment().format("YYYYMM"),
                    quarter: this.quarter,
                    year: this.year,
                    type: this.activeName == 'month' ? 'month' : 'quarter'
                }
                console.log(data);
                this.tableData = []
                await http.post('/crm/web/report/cso/getSalesDataList_cso', data).then(res => {
                    console.log(res);
                    if (res.success) {
                        this.tableData = res.data;
                        loading.close()
                    }
                })
            } catch (e) {
                loading.close()
                this.$message({
                    type: "error",
                    message: e.message,
                });
            } finally {
                loading.close()
            }
        },
        //导出数据月份
        async exportMonthDataClick() {
            this.loading = true;
            this.loadingText = "正在下载中";
            let params = {
                user_id: this.$store.getters.getUser.user_id,
                tenant_id: this.$store.getters.getUser.tenant_id,
                territory_id: this.GLOBAL.territory_id, 
                month: this.month
            };

            await axios({
                method: "post",
                url: "/wapi/derive/exportProductSales_cso",
                data: params,
                responseType: 'arraybuffer'
                // responseType: "blob",
            })
                .then((res) => {
                    console.log(res)
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                    }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
                    const elink = document.createElement("a");
                    elink.download = "销售数据明细报表.xlsx";
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                    this.loading = false;
                    this.loadingText = "拼命加载中";
                })
                .catch((e) => {
                    this.loading = false;
                    this.loadingText = "拼命加载中";
                    this.$message.error("下载失败");
                });
        },
        //导出数据月份
        async exportQuarterDataClick() {
            this.loading = true;
            this.loadingText = "正在下载中";
            let params = {
                user_id: this.$store.getters.getUser.user_id,
                tenant_id: this.$store.getters.getUser.tenant_id,
                territory_id: this.GLOBAL.territory_id, 
                year: this.year,
                quarter: this.quarter
            };

            await axios({
                method: "post",
                url: "/wapi/derive/exportProductSales_q_cso",
                data: params,
                responseType: 'arraybuffer'
                // responseType: "blob",
            })
                .then((res) => {
                    console.log(res)
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                    }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
                    const elink = document.createElement("a");
                    elink.download = "销售数据明细报表.xlsx";
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                    this.loading = false;
                    this.loadingText = "拼命加载中";
                })
                .catch((e) => {
                    this.loading = false;
                    this.loadingText = "拼命加载中";
                    this.$message.error("下载失败");
                });
        },
    },
    created() {
        this.year = moment().format('YYYY')
        const month = moment().format('M')
        if (month == 1 || month == 2 || month == 3) {
            this.quarter = 'Q1'
        } else if (month == 4 || month == 5 || month == 6) {
            this.quarter = 'Q2'
        } else if (month == 7 || month == 8 || month == 9) {
            this.quarter = 'Q3'
        } else if (month == 10 || month == 11 || month == 12) {
            this.quarter = 'Q4'
        }

        this.getSalesData()
    }
}
</script>

<style scoped>
.el-tabs--border-card {
    box-shadow: none;
    border: none;
}

.btn {
    /*text-align: right*/
}

.isActive {
    color: red;
}

.topTab {
    margin-top: 20px;
}

.HQ,
.region,
.area,
.Team,
.deputy {
    overflow: hidden;
}

.spanCss {
    display: inline-block;
    width: 50px;
    font-size: 16px;
    color: #D8D8D8;
    margin-bottom: 20px;
    float: left;
}

.disableColor ul li a {
    color: #D8D8D8 !important;
    cursor: no-drop !important;
}

.HQ-Li a {
    cursor: pointer;
}

/*ul{*/
/*    overflow: hidden;*/
/*}*/
.HQ-Li {
    float: left;
    line-height: 15px;
    margin-left: 20px;
    margin-bottom: 20px;
}

a {
    color: black;
    font-size: 14px;
    cursor: pointer;
}

p {
    margin: 0;
    padding: 0;
}

.tableCss {
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/statement/components/CSO_SalesDataReport.vue